// @core/api/endpoints/activity/delete_mapping_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DeleteMappingConfigResponse,
} from '../../../types/activity';

const BASE_PATH = '/activity';

/**
 * Delete activity mapping config
 * Removes a Kafka topic → Activity mapping configuration.
 */
export async function DeleteMappingConfig(
  id: string,
  options?: RequestOptions
): Promise<DeleteMappingConfigResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/activity-mappings/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.delete<DeleteMappingConfigResponse>(requestPath, requestOptions);
}
